import React, { createRef, Component } from 'react'

class Test extends Component {
  constructor(props) {
    super(props)
    this.state = { timer: 0, message: 'is counting', buttonMsg: 'clickMe' }
    this.inputRef = createRef()
  }
  tick = () => {
    this.setState(state => {
      return { timer: state.timer + 1 }
    })
  }
  clickButton = e => {
    console.log(e.target.attributes)
    const newMessage = `you clicked the : ${e.target.attributes['data-tag'].value}`
    this.setState({ buttonMsg: newMessage })
  }
  componentDidMount() {
    this.inputRef.current.focus()
    console.log('mounted')
    this.timerID = setInterval(() => {
      this.tick()
    }, 1000)
  }
  clickHandler = () => {
    alert(this.inputRef.current.value)
  }
  componentWillUnmount() {
    clearInterval(this.timerID)
  }
  render() {
    return (
      <>
        <div>
          <input type="text" />
        </div>
        <div>
          <input ref={this.inputRef} type="text" />
          <button onClick={this.clickHandler}>Click</button>
        </div>
        <div>
          Timer {this.state.message}: {this.state.timer}{' '}
        </div>
        <button onClick={this.clickButton} data-tag="the main button">
          {this.state.buttonMsg}
        </button>
      </>
    )
  }
}

export default Test
